import { render, staticRenderFns } from "./ElDialog.vue?vue&type=template&id=aab484be"
import script from "./ElDialog.vue?vue&type=script&lang=js"
export * from "./ElDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports